/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Exported_Csv_ToastInputs */



/**
* | output |
* | --- |
* | "Comparison exported to CSV" |
*
* @param {Compare_Event_Groups_Exported_Csv_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_exported_csv_toast = /** @type {((inputs?: Compare_Event_Groups_Exported_Csv_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Exported_Csv_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comparaison exportée en CSV")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vergleich als CSV exportiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Confronto esportato in CSV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сравнение экспортировано в CSV-файл.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comparación exportada a CSV")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("对比结果已导出为 CSV 文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("比較をCSVにエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तुलना को CSV में निर्यात किया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comparação exportada para CSV")
	return /** @type {LocalizedString} */ ("Comparison exported to CSV")
});